import React from 'react';
import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import OnfidoDocList from 'apps/auth/components/common/onfido/OnfidoDocList';
import BasePage from 'apps/auth/components/utils/BasePage';
import { useAuth, useExtra } from 'apps/auth/hooks/selectors';

const OnfidoDocListPage = (props) => {
    const { countryId } = useAuth();
    const { userType } = useParams();
    const { docs, countryInEEA, backUrl } = useExtra();
    const { titleWithParams, needHelpWithDocument } = useSelector(({ messages: { pageMessages } }) => pageMessages);

    return (
        <CommonPage backUrl={backUrl} showChat={false}>
            <HeaderPanel title={titleWithParams} />
            <OnfidoDocList acceptableDocuments={docs?.acceptableDocuments} userType={userType} userCountryId={countryId} userCountryInEEA={countryInEEA} />
            <Button
                variant="row"
                onClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
                caption={needHelpWithDocument}
                negativeMargin
            />
        </CommonPage>
    );
};
export default connect(null, { toggleChat })(BasePage(OnfidoDocListPage));
